var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 49,
    viewBox: "0 0 60 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.2481 28.6104C49.2481 38.6704 41.0981 46.8204 31.0381 46.8204C20.9781 46.8204 12.8281 38.6704 12.8281 28.6104C12.8281 18.5504 20.9781 10.4004 31.0381 10.4004C41.0981 10.4004 49.2481 18.5504 49.2481 28.6104Z",
    fill: "#FFC000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2969 10.4102V46.8102C41.2369 46.6702 49.2469 38.5902 49.2469 28.6102C49.2469 18.6302 41.2369 10.5502 31.2969 10.4102Z",
    fill: "#0098C8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3364 19.6004C37.9764 17.1704 34.6864 15.6504 31.0264 15.6504C23.8664 15.6504 18.0664 21.4504 18.0664 28.6004C18.0664 32.1804 19.5164 35.4204 21.8564 37.7604",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76562 2.80957V27.7696",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.957031 2.80957V11.3596C0.957031 14.2396 3.06703 16.5696 5.67703 16.5696C8.28703 16.5696 10.397 14.2396 10.397 11.3596V2.80957",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.0975 27.7695H3.4375V47.4795H8.0975V27.7695Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M56.7969 1V27.77",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56.6966 1C54.0866 1 51.9766 3.33 51.9766 6.21V21.14H56.7866",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0467 27.7695H54.3867V47.4695H59.0467V27.7695Z",
    stroke: "#003D6A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg9);
export default __webpack_public_path__ + "static/media/9.46f1b8330c7ec59b2553f65c066fbaeb.svg";
export { ForwardRef as ReactComponent };